import React from 'react';
import AdminTeamRecords from "../../components/admin/components/AdminTeamRecords";

const AllTeamRecords = () => {
    return <AdminTeamRecords />;
};

export default AllTeamRecords;
